import { render } from "./Q3Detaillee.vue?vue&type=template&id=3c77f3bd"
import script from "./Q3Detaillee.vue?vue&type=script&lang=js"
export * from "./Q3Detaillee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__